import { UploadZone } from "../UploadZone";
import { DocumentList } from "../DocumentList";
import { StatCards } from "../StatCards";
import { DemoButton } from "../DemoButton";
import { EligibilityPanel } from "../EligibilityPanel";
import { AlertsPanel } from "../AlertsPanel";

export default function FamilyDashboard({ user, documents, stats, refresh, docTotal, loadMore }) {
  return (
    <div data-testid="family-dashboard" className="space-y-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C07A60]">Family Portal</p>
          <h1 className="mt-2 text-3xl md:text-4xl font-heading font-light tracking-tight">
            Welcome, <span className="font-bold text-[#2E5C50]">{user.name}</span>
          </h1>
          <p className="mt-2 text-[#57605A]">
            Upload care documents and Nexari will verify them — summaries, flags and next steps in seconds.
          </p>
        </div>
        <DemoButton onSeeded={refresh} />
      </div>

      <StatCards stats={stats} />

      <AlertsPanel />

      <EligibilityPanel />

      <div className="grid lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2">
          <h2 className="text-lg font-heading font-semibold mb-4">Upload a document</h2>
          <UploadZone onUploaded={refresh} />
        </div>
        <div className="lg:col-span-3">
          <h2 className="text-lg font-heading font-semibold mb-4">Your documents</h2>
          <DocumentList documents={documents} total={docTotal} onLoadMore={loadMore} />
        </div>
      </div>
    </div>
  );
}
